import {NavigationProp} from '@react-navigation/native';

import {AppRoute} from '../models/AppRoute';
import {UserStore} from '../stores/userStore';
import {Analytics} from '../utils/analytics/analytics';
import {EventName} from '../utils/analytics/events';

const analyticsLogoutAndClearSession = () => {
  Analytics.logEvent({
    eventName: EventName.Logout,
    parameters: {},
  });
  Analytics.clearUserSession();
};

export const handleLogoutPress = async (navigation: NavigationProp<any>, userStore: UserStore) => {
  await userStore.logout();
  analyticsLogoutAndClearSession();
  navigation.navigate(AppRoute.ROOT, {
    screen: AppRoute.MAIN,
    params: {screen: AppRoute.HOME},
  });
};
